var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorGate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m37.381,4.124l-1.548.131c-1.003.085-1.968.417-2.811.966l-8.751,5.701-17.238-2.596-4.065,2.648,14.42,4.432-8.837,5.757-3.828-.618-2.036,1.327,5.202,3.561c1.205.825,2.788.843,4.011.046l23.288-15.172c1.386-.903,2.632-2.003,3.7-3.265h0c1.023-1.209.072-3.052-1.507-2.918Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.207,
    y: 34.342,
    width: 23.03,
    height: 3.541
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorGate);
export default __webpack_public_path__ + "static/media/indoor-gate.af57ace9234b8ddcf86f1ecedf3dc18e.svg";
export { ForwardRef as ReactComponent };